import { render, staticRenderFns } from "./CertificatePage.vue?vue&type=template&id=5c8cda6b&scoped=true&"
import script from "./CertificatePage.vue?vue&type=script&lang=js&"
export * from "./CertificatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8cda6b",
  null
  
)

export default component.exports